// extracted by mini-css-extract-plugin
export default {"techPageHeaderContainer":"styles_techPageHeaderContainer__8eDzZ","inputsContainer":"styles_inputsContainer__cAurr","margin":"styles_margin__l7MHw"};